import commentButtonView from './commentButtonComponent.html';
import './commentButtonComponent.css';

export function commentButtonComponent() {
	return {
		bindings: {
			post: '=',
			label: '@',
			size: '@',
			modalWidth: '@',
		},
		controllerAs: 'vm',
		controller: commentButtonComponentCtrl,
		template: commentButtonView,
	};
}

export class commentButtonComponentCtrl {
	constructor(modal, Api, Cfg) {
		'ngInject';
		this.modal = modal;
		this.Api = Api;
		this.hideLikesAndComments = Cfg.read('Features.hide_likes_and_comments') !== '0';
	}

	viewComments() {
		const update = this.updateCount.bind(this);
		const width = this.modalWidth ? this.modalWidth : 720;
		this.modal
			.state('hub.PostHistory', {
				params: { id: this.post.id },
				heading: 'Comments and Favorites',
				height: 600,
				width: width,
				attemptFocus: true,
			})
			.then(update, update);
	}

	updateCount() {
		this.Api.get(`/posts/${this.post.id}/comments`).then(comments => {
			this.post.comment_count = comments.length;
		});
	}
}
